import {
  addRxPlugin,
  createRxDatabase,
  type RxCollection,
  type RxDatabase,
} from "rxdb";
import { RxDBCleanupPlugin } from "rxdb/plugins/cleanup";
import { RxDBMigrationPlugin } from "rxdb/plugins/migration-schema";
import { getRxStorageDexie } from "rxdb/plugins/storage-dexie";
import { RxDBUpdatePlugin } from "rxdb/plugins/update";
import { CDS_DB_NAME } from "../constants";
import {
  PATIENT_CLINICAL_RESOURCE_SCHEMA,
  type PatientClinicalResource,
  RXDB_PATIENT_CLINICAL_RESOURCE_COLLECTION_NAME,
} from "./collections/patient-clinical-resource";
import { PATIENT_CLINICAL_RESOURCE_MIGRATION_STRATEGIES } from "./migration-strategies/patient-clinical-resource";

export interface RxDBCollections {
  [RXDB_PATIENT_CLINICAL_RESOURCE_COLLECTION_NAME]: RxCollection<PatientClinicalResource>;
}

export const CDS_RXDB_COLLECTIONS = {
  [RXDB_PATIENT_CLINICAL_RESOURCE_COLLECTION_NAME]: {
    schema: PATIENT_CLINICAL_RESOURCE_SCHEMA,
    migrationStrategies: PATIENT_CLINICAL_RESOURCE_MIGRATION_STRATEGIES,
  },
};

let dbInstance: RxDatabase<RxDBCollections> | null = null;

export const initDatabase = async (): Promise<RxDatabase<RxDBCollections>> => {
  if (dbInstance) {
    return dbInstance;
  }

  try {
    const storage = getRxStorageDexie();
    dbInstance = await createRxDatabase({
      name: CDS_DB_NAME,
      storage,
      multiInstance: false,
    });

    addRxPlugin(RxDBMigrationPlugin);
    addRxPlugin(RxDBCleanupPlugin);
    addRxPlugin(RxDBUpdatePlugin);

    await dbInstance.addCollections(CDS_RXDB_COLLECTIONS);

    return dbInstance;
  } catch (error) {
    console.error("Error initializing CDS database:", error);
    throw new Error("Failed to initialize CDS database.");
  }
};
